import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebButtonModule } from '../../components/web-button/web-button.module';
import { ReceiptComponent } from './receipt.component';

@NgModule({
    declarations: [ReceiptComponent],
    imports: [
        CommonModule,
        WebButtonModule
    ],
    exports: [ReceiptComponent],
})
export class ReceiptModule {}
